/* eslint-disable no-unused-vars */
import { useState, useContext, createContext, useEffect } from 'react'
import VeritcalColumnUI from './VeritcalColumnUI'
import TabsComponent from './TabsComponent'
import { FaRegSave } from "react-icons/fa";
import { ImSpinner8 } from "react-icons/im";
// import { GrLinkNext } from "react-icons/gr";
// import { GrLinkPrevious } from "react-icons/gr";
import { HiOutlineRefresh } from "react-icons/hi";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { GoSidebarCollapse } from "react-icons/go";
import { GoSidebarExpand } from "react-icons/go";
import { AppContext } from '../contexts/AppContext';
import { AuthContext } from '../contexts/AuthContext';
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
// import WeeklyVolume from "./WeeklyVolume";
import useCurrentWeekRange from '../hooks/useCurrentWeekRange';
import reshapeProjectionResults from '../utils/reshapeProjectionResults';
import { getWeeklyMaster, saveEditedProjectionToBackendasync, updateProjectionValues, saveSopEditedProjectionToBackendasync } from '../services/forecastService';
import getCurrentWeekNumFromWeeklyTable from '../utils/getCurrentWeekNumFromWeeklyTable';
import convertNullsToZeroNested from '../utils/convertNullsToZero';
import DemoProductThumbnails from './DemoProductThumbnails';

export const EditContext = createContext();

export default function RightCompoent({ tabs, selectedItemName, isSingleModel, sopData }) {
  console.log("sopData", sopData)
  const { user } = useContext(AuthContext);
  const currentWeekRange = useCurrentWeekRange();
  const [refreshCount, setRefreshCount] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [active, setActive] = useState('demand-forecast');
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [hasEdited, setHasEdited] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  // console.log("selectedName", selectedItemName);

  // Projection and Editing states
  // const [editingInputsValues, setEditingInputsValues] = useState([]);
  const [editingWeekNo, setEditingWeekNo] = useState(null);
  const [editingWeekIndex, setEditingWeekIndex] = useState(null);
  // const [projectedValues, setProjectedValues] = useState([]);
  // const [projectedValuesLoaded, setProjectedValuesLoaded] = useState(false);
  // edited aggregation values
  // const [projectedMonthlyAggregationEdited, setProjectedMonthlyAggregationEdited] = useState({});

  const [requestOpenInput, setRequestOpenInput] = useState(false)
  const [selectedType, setSelectedType] = useState('tertiary');

  const HandlertabActive = (e) => {
    setActive(e)
  }
  const tabsData = [
    { id: 0, label: "Forecast" },
    { id: 1, label: "Consensus" },
    { id: 2, label: "Fcst Accuracy" },
  ]
  const { toggle, setToggle, PastActualsOneFunc, PastActualsTwoFunc, PastForecastOneFunc, PastForecastTwoFunc,
    PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue, projectedValues, setProjectedValues, projectedValuesLoaded, setProjectedValuesLoaded, editingInputsValues, setEditingInputsValues, projectedMonthlyAggregationEdited, setProjectedMonthlyAggregationEdited, activeTab
  } = useContext(AppContext);

  const handleEditBtnClick = () => {
    console.log("Input Fields are now editable");
    setIsEditEnabled(prev => !prev)
    const enabling = !isEditEnabled;
    if (enabling) {
      setRequestOpenInput(true);
    }
    setIsEditEnabled(enabling);
  }

  const onProcess = async () => {
    setHasEdited(false);
    const weekMasterData = await getWeeklyMaster();
    const currentWeekNumber = getCurrentWeekNumFromWeeklyTable(weekMasterData)

    setProjectedValuesLoaded(false);

    const reCalculatedData = await updateProjectionValues(selectedItemName, currentWeekNumber, editingInputsValues);
    console.log("retunred vlaues", reCalculatedData)

    const projectionChangedData = reshapeProjectionResults(reCalculatedData?.recalculated_values?.results)

    console.log("projectoinChangedData", projectionChangedData)
    // console.log("projection changed data: ", projectionChangedData)
    setProjectedValues(projectionChangedData)
    setProjectedMonthlyAggregationEdited(reCalculatedData?.monthly_aggregation_for_projection)
    setCanSave(true)
    setIsEditEnabled(false)
    setProjectedValuesLoaded(true);
  }

  const handleSave = async () => {
    const payloadToSave = {
      ...projectedValues,
      input: editingInputsValues,
      monthly_aggregation: projectedMonthlyAggregationEdited || null
    }
    console.log("payloadtosave", payloadToSave)
    const cleanedPayload = convertNullsToZeroNested(payloadToSave)

    console.log("final data", cleanedPayload)
    setIsSaving(true);
    try {
      await saveEditedProjectionToBackendasync(selectedItemName, cleanedPayload);
      console.log("✅ Saved successfully");
      setCanSave(false);
      setHasEdited(false);
    } catch (err) {
      console.error("❌ Save failed:", err);
      alert("❌ Save failed");
    } finally {
      setIsSaving(false);
    }
  }

  const handleSopSave = async () => {
    const payloadToSave = {
      input: editingInputsValues,
    }

    console.log("payloadtosave", payloadToSave)
    const cleanedPayload = convertNullsToZeroNested(payloadToSave)

    console.log("final data", cleanedPayload)
    try {
      await saveSopEditedProjectionToBackendasync(selectedItemName, cleanedPayload);
      console.log("✅ Saved successfully");
    } catch (err) {
      console.error("❌ Save failed:", err);
      alert("❌ Save failed");
    }
  }

  const handleTypeSelection = async (e) => {
    const type = e.target.value;
    setSelectedType(type)
  }

  useEffect(() => {
    console.log("projectedValues from rightComponenet", projectedValues)
  }, [projectedValues])

  // reset the edit and related save states on model change
  useEffect(() => {
    // whenever model changes, cancel edit mode and reset related edit state
    setIsEditEnabled(false);
    setHasEdited(false);
    setCanSave(false);

    // reset editing/projection state so child components get a clean slate
    setEditingInputsValues([]);    // clear any transient input edits
    setEditingWeekNo(null);
    setEditingWeekIndex(null);
    setProjectedValues([]);        // optional: clear projections (or keep if you prefer)
    setProjectedValuesLoaded(false);

    setRequestOpenInput(false)
  }, [selectedItemName, setEditingInputsValues, setProjectedValues, setProjectedValuesLoaded]);

  const isModelSelection = () => {
    if (!selectedItemName || !sopData) return false;

    const allModels = Object.values(sopData || {}).flat();

    return allModels.some(model => model.name === selectedItemName);
  };

  return (
    <div data-testid="right-component" className={`${toggle ? 'container' : 'container-fixed'} h-full `}>
      <VeritcalColumnUI heightValue="570px">
        <div className='tab_top_vertical'>
          <div className='flex justify-between w-full items-center'>
            <div className='_page_width justify-between'>
              {toggle ? (<button data-testid="sidebar-expand-button" className="button-primary" title="Full Width" onClick={() => setToggle(!toggle)}><GoSidebarExpand /></button>) : (
                <button data-testid="sidebar-collapse-button" className="button-primary" title="Fixed Width" onClick={() => setToggle(!toggle)}><GoSidebarCollapse /></button>)
              }
            </div>
            <div className='_center_width text-center w-11/12 ms-2'>
              {activeTab === 1 || activeTab === 2 ? (
                <>
                  <div className='flex justify-center items-center groups mr-auto' onChange={handleTypeSelection}>
                    <button data-testid="projected-past-label" className='p-[0.5px] px-3 text-white text-xs font-semibold uppercase tracking-wider' style={{ background: '#002FA7', border: 'none', fontFamily: "'IBM Plex Sans', sans-serif" }}> {activeTab === 2 ? "Past" : "Projected "} </button>
                    <select data-testid="type-select" className='ml-4 button-primary period_selection__select' >
                      <option value='tertiary'>Tertiary</option>
                      <option value='primary'>Primary</option>
                      <option value='secondary'>Secondary</option>
                    </select>
                  </div>
                </>
              ) : (
                <div className='flex justify-center items-center groups mr-auto'>
                  <button data-testid="toggle-last-yr-actuals" className='button-primary _btn_custom' onClick={PastActualsOneFunc}> Last Yr. Actuals <span>{PastActualsOneValue ? <CiSquareMinus /> : <CiSquarePlus />}</span></button>
                  <button data-testid="toggle-past-actuals" className='button-primary _btn_custom' onClick={PastActualsTwoFunc}> Past Actuals <span>{PastActualsTwoValue ? <CiSquareMinus /> : <CiSquarePlus />}</span> </button>
                  <button data-testid="toggle-past-forecast" className='button-primary _btn_custom' onClick={PastForecastOneFunc}> Past Forecast <span>{PastForecastOneValue ? <CiSquareMinus /> : <CiSquarePlus />}</span>  </button>
                  <button data-testid="toggle-projected" className='button-primary _btn_custom' onClick={PastForecastTwoFunc}> Projected <span>{PastForecastTwoValue ? <CiSquareMinus /> : <CiSquarePlus />}</span> </button>
                </div>
              )
              }
              <button data-testid="current-week-range" className='button-primary mr-auto' style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '0.72rem', fontWeight: 500 }}> {currentWeekRange}</button>
            </div>
            <div className="_right_tabs">
              {activeTab === 2 ? "" : <ul className="_nav__right">
                {activeTab === 1 ? (
                  user?.is_sop_admin === 1 || user?.is_consensus_admin === 1 ? (
                    <>
                      <li>
                        <button
                          data-testid="sop-save-button"
                          className="button-primary"
                          title="Save"
                          onClick={handleSopSave}
                        >
                          <FaRegSave />
                        </button>
                      </li>
                    </>
                  ) : null
                ) : (
                  <>
                    <li>
                      <button
                        data-testid="save-forecast-button"
                        className="button-primary"
                        title="Save"
                        disabled={!canSave || isSaving}
                        onClick={handleSave}
                        style={canSave && !isSaving ? { background: '#002FA7', color: '#fff', borderColor: '#002FA7' } : {}}
                      >
                        {isSaving ? <ImSpinner8 className="animate-spin" /> : <FaRegSave />}
                      </button>
                    </li>

                    <li>
                      <button
                        data-testid="edit-forecast-button"
                        className="button-primary"
                        title="Edit"
                        onClick={handleEditBtnClick}
                        style={isEditEnabled ? { background: '#002FA7', color: '#fff', borderColor: '#002FA7' } : {}}
                      >
                        <MdOutlineModeEditOutline />
                      </button>
                    </li>

                    {/* Optional navigation buttons */}
                    {/* 
                    <li>
                      <button className="button-primary" title="Previous">
                        <GrLinkPrevious />
                      </button>
                    </li>
                    <li>
                      <button className="button-primary" title="Next">
                        <GrLinkNext />
                      </button>
                    </li>
                    */}

                    <li>
                      <button
                        data-testid="refresh-forecast-button"
                        className={`button-primary`}
                        title="Refresh"
                        disabled={!selectedItemName || !hasEdited || isRefreshing}
                        onClick={onProcess}
                        style={hasEdited ? { background: '#F4F4F5' } : {}}
                      >
                        <HiOutlineRefresh />
                      </button>
                    </li>
                  </>
                )}
              </ul>}
            </div>
          </div>

          {/* <div className='type_selection'>
          <span className='mr-2'>Type</span>
            <select className='type_selection__select button-primary '>
                <option>National</option>
                <option>Regional</option>
            </select>
          </div> */}
        </div>

        <div className='tabs h-full'>
          <div className='tab_content h-full'>
            <div className='tab_container h-full'>
              <div className='tab_content__left h-full' style={{ display: active === 'demand-forecast' ? 'block' : 'none' }}>
                <div className='tab_content_header_left_title h-full'>
                  <div className='container_right_navs h-full'>
                    <DemoProductThumbnails selectedItemName={selectedItemName} sopData={sopData} />
                    {/* provider component for exposing data */}
                    <EditContext.Provider value={{
                      editingInputsValues, setEditingInputsValues,
                      editingWeekNo, setEditingWeekNo,
                      editingWeekIndex, setEditingWeekIndex,
                      projectedValues, setProjectedValues,
                      projectedValuesLoaded, setProjectedValuesLoaded,
                      projectedMonthlyAggregationEdited, setProjectedMonthlyAggregationEdited,
                      setHasEdited, setCanSave, requestOpenInput, setRequestOpenInput
                    }}>
                      <TabsComponent tabs={tabsData} selectedItemName={selectedItemName} refreshCount={refreshCount} onRefreshComplete={() => setIsRefreshing(false)} isEditEnabled={isEditEnabled} sopData={sopData} selectedType={selectedType} isSingleModel={isSingleModel} />
                    </EditContext.Provider>

                  </div>
                </div>
                <div className='tab_content_header_left_button'>
                </div>
              </div>
              <div className='tab_content__right' style={{ display: active === 'waterfall-chart' ? 'block' : 'none' }}>
                <div className='tab_content_header_right_title'>
                  <h3>Waterfall Chart</h3>
                  <p>Waterfall Chart for the next 12 months</p>
                </div>
                <div className='tab_content_header_right_button'>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VeritcalColumnUI >
      {/* <VeritcalColumnUI>
        <div>bottom Veritcal content Component</div>
    </VeritcalColumnUI> */}
    </div >
  )
}
